(function () {
  var EXPERIMENT = 'home_under_collection_test';
  var SEC_3000 = 'featured_collection_GtMyx9';
  var SEC_5000 = 'featured_collection_under5000';

  function applyVariant(client) {
    var experiment = client.getExperiment(EXPERIMENT);
    var handle = experiment.get('collection_handle', 'under-pkr-3000');
    var isTreatment = handle === 'under-pkr-5000';

    var el3000 = document.querySelector('section[id$="__' + SEC_3000 + '"]');
    var el5000 = document.querySelector('section[id$="__' + SEC_5000 + '"]');

    if (!el3000 || !el5000) return;

    if (isTreatment) {
      el3000.style.display = 'none';
      el5000.style.display = 'block';
    } else {
      el5000.style.display = 'none';
      el3000.style.display = 'block';
    }
  }

  function init() {
    if (window.__statsigReady && window.__statsigClient) {
      applyVariant(window.__statsigClient);
      return;
    }
    var iv = setInterval(function () {
      if (window.__statsigReady && window.__statsigClient) {
        clearInterval(iv);
        applyVariant(window.__statsigClient);
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
